module.exports = __webpack_public_path__ + "static/media/copas_icon.90ddf782.svg";